module.exports = __webpack_public_path__ + "static/img/Tabela2.1dd3116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tabela2.jpg
// module id = 1IBX
// module chunks = 1